import {
  GroupedBucketedQueryRuns,
  GroupedBucketedQueryRunWithGroupedRunConnection,
} from './types';

export function isAggregatedRuns(
  runs: GroupedBucketedQueryRuns | null | undefined
): runs is GroupedBucketedQueryRunWithGroupedRunConnection {
  return runs?.__typename === 'GroupedRunConnection';
}
